<template>
  <base-material-card color="primary" icon="mdi-folder-network-outline" inline class="ml-0" :title="cardTitle">
    <div>
      <v-text-field v-model="search" append-icon="mdi-magnify" class="mb-5 mt-4" label="Buscar" hide-details single-line />
    </div>

    <v-row v-if="loadingTreeView" class="my-4" align="center" justify="center">
      <v-progress-circular indeterminate width="2" />
    </v-row>

    <v-treeview
      v-else
      :items="items"
      :active.sync="active"
      :open.sync="openTabs"
      :search.sync="search"
      activatable
      item-key="id"
      open-on-click
      :multiple-active="false"
      :transition="true"
      class="mt-4"
    >
      <template v-slot:prepend="{ item, open, leaf }">
        <v-icon v-if="leaf" :key="item.id + tables[item.id]">
          {{ item.id in tables ? 'mdi-table' : '' }}
        </v-icon>
        <v-icon v-else>
          {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
        </v-icon>
      </template>

      <template v-slot:label="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" class="text-truncate" v-on="on">
              {{ item.name }}
            </div>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
      </template>
    </v-treeview>
  </base-material-card>
</template>

<script>
  import ExtracoesBdgdService from '@/services/ExtracoesBdgdService';

  export default {
    name: 'ExtracoesBdgdEstruturaBanco',

    props: {
      bdgdId: {
        type: [Number, String],
        required: true
      }
    },

    data() {
      return {
        items: [],
        active: [],
        tables: [],
        openTabs: [],
        databaseStructure: [],
        bdgdVersao: null,
        search: null,
        loadingTreeView: false
      };
    },

    computed: {
      selectedTable() {
        const selected = this.active.length ? this.active[0] : null;
        const item = this.tables[selected] ?? null;
        return item ? item.tabela : null;
      },
      cardTitle() {
        return this.bdgdVersao ? `BDGD - ${this.bdgdVersao.mes} v${this.bdgdVersao.versao}` : 'BDGD';
      }
    },

    created() {
      this.init();
    },

    methods: {
      async init() {
        this.loadingTreeView = true;
        try {
          await this.getBdgdVersao();
          await this.getDatabaseStructure();
        } finally {
          this.mountItemsDirectory();
        }
      },

      getBdgdVersao() {
        return ExtracoesBdgdService.getBdgdVersao(this.bdgdId)
          .then(({ data }) => {
            this.bdgdVersao = data;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao buscar os dados da versão BDGD.', '', { position: 'topRight' });
          });
      },

      getDatabaseStructure() {
        return ExtracoesBdgdService.getDatabaseStructure(this.bdgdId)
          .then(({ data }) => {
            this.databaseStructure = Object.entries(data);
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao buscar a estrutura do banco de dados.', '', { position: 'topRight' });
          });
      },

      mountItemsDirectory() {
        this.items = this.databaseStructure.map(([database, databaseValue], index) => ({
          id: index + 1,
          name: database,
          disabled: false,
          children: Object.entries(databaseValue).map(([schema, tableValue], schemaIndex) => ({
            id: `${index + 1}.${schemaIndex + 1}`,
            name: schema,
            children: Object.entries(tableValue).map(
              ([, value], tableIndex) => (
                (this.tables[`${index + 1}.${schemaIndex + 1}.${tableIndex + 1}`] = {
                  tabela: value,
                  path: schema
                }),
                {
                  id: `${index + 1}.${schemaIndex + 1}.${tableIndex + 1}`,
                  name: value
                }
              )
            )
          }))
        }));
        this.loadingTreeView = false;
      },

      emitData() {
        this.$emit('update-values', {
          selectedTable: this.selectedTable,
          bdgdId: this.bdgdId,
          tables: this.tables,
          active: this.active
        });
      }
    },

    watch: {
      selectedTable() {
        this.emitData();
      },
      active() {
        this.emitData();
      },
      tables: {
        handler() {
          this.emitData();
        },
        deep: true
      }
    }
  };
</script>
